import { connect } from 'react-redux';

import get from 'lodash/get';

import RejectVisitorComponent from './RejectVisitorComponent';

import { VISITOR_REJECT_SUBMITTED } from '../../actionConstants';

import apiClient from '../../apiClient';

const form = 'RejectVisitor';

const mapStateToProps = (state, ownProps) => ({
  form,
  residents: get(state, 'callCenter.residents'),
  staff: get(state, 'callCenter.staff'),
  building: get(state, 'callCenter.building'),
  selectedCameraId: get(state, 'callCenter.selectedCameraId'),
  ...ownProps,
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data, props) => {
    const { building, onModalClose, selectedCameraId: camera } = props;
    const buildingId = building?.id;
    return dispatch({
      type: VISITOR_REJECT_SUBMITTED,
      payload: apiClient.callCenter.rejectVisitor(buildingId, {
        ...data,
        camera,
      }),
      successMessage: 'Visitor rejected',
      callback: (res) => {
        // There is no response in case of an error
        if (!res) return;
        onModalClose && onModalClose();
      },
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RejectVisitorComponent);
